// BookInfo.js
import React from 'react';
import { propsToText } from '../utils/functions';
import StaticStarRating from './StaticStarRating';

const BookInfo = ({ book, t }) => (
  <div className="book-info">
    <div className="book-header">
      <h2 className="fs-l">{book.title}</h2>
      <span className="fs-m pt-85">
        {propsToText(book.author_name, 1) || 'N/A'}
      </span>
      {book.status === 'read' && <StaticStarRating rating={book.rating} />}
    </div>
    <div className="book-details">
      <span className="fs-xs pt-65">
        {t.pages}: {book.number_of_pages || 'unknown'}
      </span>
      <span className="fs-xs pt-65">
        {t.published}: {propsToText(book.publish_date, 1) || 'unknown'}
      </span>
      <span className="fs-xs pt-65">
        {t.publisher}: {propsToText(book.publisher, 1) || 'unknown'}
      </span>
      <span className="fs-xs pt-65">
        {t.isbn}: {propsToText(book.isbn, 1) || 'unknown'}
      </span>
    </div>
  </div>
);

export default BookInfo;
